import React from "react";
//#region types
import { TodoChipsListSkeletonProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import TodoChipSkeleton from "./todoChipSkeleton";
//#endregion

const TodoChipsListSkeleton: React.FC<TodoChipsListSkeletonProps> = (props) => {
  const { totalItems, columnsXs, columnsMd } = props;

  return (
    <Grid container spacing={1} direction="row">
      {[...Array(totalItems).keys()].map((columnIndex) => (
        <Grid key={columnIndex} item xs={12 / columnsXs} md={12 / columnsMd}>
          <TodoChipSkeleton />
        </Grid>
      ))}
    </Grid>
  );
};

export default TodoChipsListSkeleton;
